import { isUnscheduledAppointment } from 'Data/format.js'

export function isNotUnscheduledAppointment(appointment) {
  return !isUnscheduledAppointment(appointment)
}
